import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BrandProfile } from 'src/environments/brand-profiles';

export type { BrandProfile };

export function resolveBrand(hostname: string): BrandProfile {
  const profiles = environment.brandProfiles;
  const normalized = hostname.trim().toLowerCase().replace(/\.$/, '');
  const match = profiles.find(profile =>
    profile.hostnames.includes(normalized)
  );
  if (match) {
    return match;
  }

  const fallback = profiles.find(profile => profile.isDefault);
  if (!fallback) {
    throw new Error('Brand configuration is missing a default profile');
  }
  return fallback;
}

@Injectable({
  providedIn: 'root',
})
export class BrandingService {
  readonly brand: BrandProfile;

  constructor() {
    this.brand = resolveBrand(window.location.hostname);
    this.apply(this.brand);
  }

  private apply(brand: BrandProfile): void {
    const root = document.documentElement;
    root.style.setProperty('--brand-primary', brand.primaryColor);
    root.style.setProperty('--brand-button', brand.buttonColor);
    const background = brand.loginBackgroundUrl
      ? `url("${brand.loginBackgroundUrl}")`
      : 'none';
    root.style.setProperty('--brand-login-background', background);
  }
}
